module.exports = __webpack_public_path__ + "img/wanke.bf7009b8.png";